import React from 'react';
import classNames from 'classnames';

const Auth = props => {
    return (
        <div className={classNames({
            'auth': true,
            ...props.modifiers
        })}>
            <div className="auth__content-outer">
                <div className="auth__content">
                    {props.heading &&
                        <h1 className="auth__heading">{props.heading}</h1>
                    }
                    <div id="api"></div>
                </div>
            </div>
            <div className="auth__vis"></div>
        </div>
    );
};

export default Auth;